(() => {
  const mobileQuery = window.matchMedia('(max-width: 767px)');
  const triggerOffset = 100;
  let frameRequested = false;

  const enlargeNativeChatIcon = (chat) => {
    const root = chat.shadowRoot;
    if (!root || root.querySelector('#yiri-native-chat-icon-size')) return;

    const style = document.createElement('style');
    style.id = 'yiri-native-chat-icon-size';
    style.textContent = `
      .activator__icon,
      .activator__icon > svg {
        width: 24px !important;
        height: 24px !important;
        min-width: 24px !important;
      }
    `;
    root.appendChild(style);
  };

  // Inbox nests its activator inside a positioned container, so `right` on ::part(activator)
  // lands off by that container's offset. Measure and cancel the difference so the chat
  // button shares a vertical axis with the back-to-top button.
  const findActivator = (root) => {
    for (const el of root.querySelectorAll('*')) {
      if (el.getAttribute && (el.getAttribute('part') || '').split(' ').includes('activator') && el.tagName === 'BUTTON') return el;
      if (el.shadowRoot) {
        const hit = findActivator(el.shadowRoot);
        if (hit) return hit;
      }
    }
    return null;
  };

  const alignChat = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat || !chat.shadowRoot) return;
    const activator = findActivator(chat.shadowRoot);
    if (!activator) return;
    const current = parseFloat(chat.style.getPropertyValue('--yiri-chat-dx')) || 0;
    const a = activator.getBoundingClientRect();
    if (!a.width) return;
    // Target: where the stylesheet places the back-to-top button (its live rect is unreliable
    // while it is hidden or animating in). Keep in step with yiri-mobile-floating-actions.css.
    const right = mobileQuery.matches ? window.innerWidth * 0.1 - 22 : 40;
    const targetCenter = window.innerWidth - right - 22;
    const naturalCenter = a.left + a.width / 2 - current;
    const dx = Math.round(targetCenter - naturalCenter);
    if (dx !== current) chat.style.setProperty('--yiri-chat-dx', dx + 'px');
  };

  const updateChatVisibility = () => {
    frameRequested = false;
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;

    enlargeNativeChatIcon(chat);
    const shouldShow = mobileQuery.matches && window.scrollY > triggerOffset;
    chat.classList.toggle('yiri-scroll-actions-visible', shouldShow);
    alignChat();
  };

  const requestUpdate = () => {
    if (frameRequested) return;
    frameRequested = true;
    window.requestAnimationFrame(updateChatVisibility);
  };

  const observeChat = () => {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return false;

    enlargeNativeChatIcon(chat);
    updateChatVisibility();
    if (chat.shadowRoot) {
      new MutationObserver(() => { enlargeNativeChatIcon(chat); requestUpdate(); }).observe(chat.shadowRoot, {
        childList: true,
        subtree: true,
      });
    }
    new MutationObserver(requestUpdate).observe(chat, {
      attributes: true,
      attributeFilter: ['open'],
    });
    // The activator renders a moment after the element; re-align once it has settled.
    [800, 2500].forEach((ms) => window.setTimeout(requestUpdate, ms));
    return true;
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  mobileQuery.addEventListener?.('change', requestUpdate);

  if (!observeChat()) {
    const observer = new MutationObserver(() => {
      if (observeChat()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
